import Model from 'src/app/common/model';

export default class BroodLineModel extends Model {
    id: string;
    name: string;
    code: string;
    description: string;
    breeder_id: number;
    createdby: string;
    updatedby: string;
    createdAt: Date;
    updatedAt: Date;

    constructor() {
        super();
    }
}
